// extracted by mini-css-extract-plugin
module.exports = {"root":"ProposalForm__root___3ljyr","addSpace":"ProposalForm__addSpace___2cRPm","upload":"ProposalForm__upload___3Vv_V"};